<div
  *ngIf="getFilteredSeekingAndOfferings({accountGoals, accountMembership})?.length"
  class="bg-color-white mat-elevation-z1 u-borderRadius--4px u-padding-24 u-display-block u-marginBottom-16"
>
  <p class="text-subtitle-1 u-marginBottom-16">Update your development goals</p>
  <div class="text-body-2 color-grey-300 u-marginBottom-16">
    <p class="u-marginBottom-16">
      You can now update your goals to curate your experiences on 10KC. This
      will help you:
    </p>
    <ul class="u-padding-0-16">
      <li>Set objectives for your experiences</li>
      <li>Choose who you want to work with for your goals</li>
    </ul>
  </div>
  <button
    mat-raised-button
    color="primary"
    [routerLink]="'/update-goals'"
    [queryParams]="{ groupId: group._id }"
  >
    Update goals
  </button>
</div>
